export const languagesSelector = state => state.translation.strings;
